module.exports = __webpack_public_path__ + "e7861bab7fde8f4029cb307ae690f6d7.svg";